export default __webpack_public_path__ + "static/media/fouziaaldraihem.56d4f932.jpg";